import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';
import styles from './ContentCardCollectible.module.less';

export default function ContentCardCollectible({
  collected = false,
  onClick = null,
}) {
  return (
    <div className={styles.container}>
      <Button
        className={styles.button}
        onClick={(e) => {e.stopPropagation(); e.preventDefault(); onClick(e)}}
        color="tertiary"
        title={collected ? 'Remove from collection' : 'Add to collection'}
      >
        <Icon
          name={collected ? 'bookmark-filled' : 'bookmark'}
          className={styles.icon}
        />
      </Button>
    </div>
  );
}

ContentCardCollectible.displayName = 'ContentCardCollectible';
ContentCardCollectible.propTypes = {
  collected: PropTypes.bool,
  onClick: PropTypes.func,
};
